import script from "./VAlertCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./VAlertCustom.vue?vue&type=script&setup=true&lang=js"

import "./VAlertCustom.vue?vue&type=style&index=0&id=f4608f74&scoped=true&lang=css"

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4608f74"]])

export default __exports__